var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"downBtn",attrs:{"size":"small","type":_vm.type,"icon":_vm.icon},on:{"click":function($event){$event.stopPropagation();return _vm.download(_vm.data)}}},[_vm._t("ButtonName")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }